import {useEffect, useState} from "react";
import {debounce} from "@mui/material";

/**
 * A hook that observes window resize events and calls the given callback
 * function.
 *
 * @param {function} callback The function to call when the window is resized.
 * @return {object} An object with `height` and `width` properties that
 *     represent the current window dimensions.
 */
export const useObserveWindowResize = (callback) => {
    const [dimensions, setDimensions] = useState({
        height: window.innerHeight,
        width: window.innerWidth,
    });

    useEffect(() => {
        const debouncedHandleResize = debounce(function handleResize() {
            setDimensions({
                height: window.innerHeight,
                width: window.innerWidth,
            });
            if (callback) {
                callback();
            }
        }, 200);
        window.addEventListener("resize", debouncedHandleResize);
        return () => {
            window.removeEventListener("resize", debouncedHandleResize);
        };
    }, [callback]);

    return dimensions;
};
